import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Constants } from "../../CommonMethhods/Constants";
import Loader from "../../Components/Common/Loader";
import Header from "../../Components/Header";
import ClientAumTable from "../../Components/ReportTables/ClientAumTable";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Sidebar from "../../Components/Sidebar";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { useDebounce } from "../../Components/useDebounce";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function ClientWiseAumReport() {
  const [loader, setLoader] = useState(false);
  const storeToken = localStorage.getItem("ssoToken");
  const [checkResp, setCheckResp] = useState([]);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [searchLoader, setSearchLoader] = useState(false);
  const [serverError, setServerError] = useState("");
  const [count, setCount] = useState();
  const [clientCode, setClientCode] = useState("");
  const [error, setError] = useState(false);
  const [show, setShow] = useState(false);

  const debouncedValue = useDebounce(clientCode, 1000);
  useEffect(() => {
    setLoader(true);
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  const getClientWiseAumReport = async (
    fileType,
    sizePage,
    pageNo = 1,
    mainLoader = false
  ) => {
    let clientCo = document.querySelector("#SearchInput_ClientWish").value;

    if (fileType === "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
    }
    if (fileType === "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
    }
    if (mainLoader) {
      setSmallLoaderExcel(false);
      setLoader(true);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      pageNo: pageNo,
      pageSize: sizePage,
      type: fileType,
      clientCode: clientCo,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getAumDetails = await axiosInstance.post(
        Dashboard_Client_Report.AumClientReport_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getAumDetails?.data);

      if (res?.status === 0) {
        setError(false);
        if (fileType === "grid") {
          setCount(res?.data?.totalCount);
          if (page > 1) {
            setCheckResp((prev) => {
              return [...prev, ...res?.data.aumClients];
            });
          } else {
            setCheckResp(res?.data?.aumClients);
          }
        } else if (fileType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        setCheckResp([]);
        if (fileType === "excel") {
          toast.error("AUM Report does not exist.");
        } else if (fileType === "pdf") {
          toast.error("AUM Report does not exist.");
        } else {
          setError(res?.message);
          setShow(false);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError("Something went wrong, Please try again later.");
      if (fileType === "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType === "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (clientCode !== "" && fileType === "grid") {
        toast.error("Something went wrong, Please try again later.");
        setClientCode("");
      }
    } finally {
      setLoader(false);
      setSearchLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setScrollLoader(false);
    }
  };

  useEffect(() => {
    if (page > 1) {
      getClientWiseAumReport("grid", 10, page, false);
    }
  }, [page]);

  const handleScroll = (e) => {
    setPageSize(10);
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= pageSize * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  const handleScrollUl = (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !searchLoader) {
      if (!(count <= pageSize * page)) {
        setPage((prev) => prev + 1);
        setSearchLoader(true);
      }
    }
  };

  const handleOnClick = (e) => {
    if (e.target.value) {
      getClientWiseAumReport(e.target.value, -1, 1, false);
    }
  };

  function handleClientName(data) {
    setCheckResp([]);
    setError(false);
    setSearchLoader(true);
    getClientWiseAumReport("grid", 10, 1, data === "");
  }

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box aum-report">
          <div className="figure-inlac">
            <h2 className="report-title">{Constants.Client_Wise_AUM_Report}</h2>
            <p>{Constants.Figure_In_Lacs_for_all}</p>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">{Constants.Product_Type}</label>
                <select>
                  <option value="stocks">All</option>
                </select>
              </div>
            </div>

            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">{Constants.Client_Search}</label>

                <div className="rm-custom-dropdown">
                  <input
                    type="text"
                    name="search-text"
                    id="SearchInput_ClientWish"
                    className="input-st"
                    placeholder="Search here..."
                    autoComplete="off"
                    value={clientCode}
                    onChange={(e) => {
                      setClientCode(e.target.value.toUpperCase());
                      setShow(true);
                      setPage(1);
                    }}

                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                      
                  }}
                  />
                  <button
                    className="rm-dropdown-btn"
                    onClick={() => setShow(!show)}
                  >
                    <span className="icon-right-arrow-triangle"></span>
                  </button>
                  {show && (
                    <>
                      <ul
                        className="rm-mapping-ap border-0"
                        onScroll={(e) => handleScrollUl(e)}
                      >
                        {checkResp &&
                          checkResp.map((item, i) => (
                            <li
                              key={i}
                              onClick={() => {
                                setShow(false);
                                document.querySelector(
                                  "#SearchInput_ClientWish"
                                ).value = item?.clientCode;
                                // setLoader(true);
                                setClientCode(item?.clientCode);
                              }}
                              className="rm-maping-item-wrapper"
                            >
                              <div> {item?.clientName}</div>
                              <div> {item?.clientCode}</div>
                            </li>
                          ))}
                        {searchLoader && !loader && (
                          <div className="loader-center">
                            <LoaderForSearch />
                          </div>
                        )}
                      </ul>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div>
            <ReportTableHeader
              showEmailBtn={false}
              smallLoaderExcel={smallLoaderExcel}
              smallLoaderPdf={smallLoaderPdf}
              handleOnClick={handleOnClick}
            />
          </div>
          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : checkResp && checkResp.length > 0 ? (
              <div>
                <ClientAumTable
                  checkResp={checkResp}
                  handleScroll={handleScroll}
                  scrollLoader={scrollLoader}
                />
              </div>
            ) : error ? (
              <h4 className="report-error-message">{noDataFound(error)}</h4>
            ) : serverError ===
              "Something went wrong, Please try again later." ? (
              <h4 className="report-error-message">{serverError}</h4>
            ) : (
              ""
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default ClientWiseAumReport;
